import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import ThemeModeProvider from "../../theme/ThemeModeProvider";
import AppShell from "../App";

function patchWebpackChunkVersioning() {
  let assetVersion = typeof window !== "undefined" ? String(window.__MT_ASSET_VERSION__ || "").trim() : "";
  if (!assetVersion) {
    try {
      const scriptURL = new URL(import.meta.url);
      const params = new URLSearchParams(scriptURL.search);
      assetVersion = String(params.get("v") || scriptURL.search.replace(/^\?/, "") || "").trim();
    } catch (error) {
      assetVersion = "";
    }
  }

  if (!assetVersion) return;
  if (typeof __webpack_require__ === "undefined") return;
  if (typeof __webpack_require__.u !== "function") return;
  if (__webpack_require__.__mtChunkVersionPatched) return;

  const originalResolveChunkPath = __webpack_require__.u.bind(__webpack_require__);
  __webpack_require__.u = (chunkId) => {
    const chunkPath = String(originalResolveChunkPath(chunkId) || "");
    if (!chunkPath) return chunkPath;
    if (chunkPath.includes("?")) {
      return `${chunkPath}&v=${assetVersion}`;
    }
    return `${chunkPath}?v=${assetVersion}`;
  };
  __webpack_require__.__mtChunkVersionPatched = true;
}

function parseShellProps() {
  const fallbackPath =
    typeof document !== "undefined" && document.location
      ? document.location.pathname
      : "/";
  const fallbackURI =
    typeof document !== "undefined" && document.location
      ? `${document.location.pathname}${document.location.search}`
      : "/";

  const fallback = {
    authenticated: false,
    path: fallbackPath,
    requestURI: fallbackURI,
    links: [],
  };

  const node = document.getElementById("react-admin-shell-props");
  if (!node) return fallback;

  try {
    const raw = JSON.parse(node.textContent || "{}");
    return {
      ...fallback,
      ...(raw || {}),
      path: raw?.path || fallback.path,
      requestURI: raw?.requestURI || fallback.requestURI,
      links: Array.isArray(raw?.links) ? raw.links : [],
    };
  } catch (error) {
    return fallback;
  }
}

function AdminShell(props) {
  if (!props?.authenticated) return null;
  return (
    <ThemeModeProvider>
      <BrowserRouter>
        <AppShell {...props} />
      </BrowserRouter>
    </ThemeModeProvider>
  );
}

export function mountReactAdminShell() {
  patchWebpackChunkVersioning();

  const mountNode = document.getElementById("react-admin-root");
  if (!mountNode || mountNode.dataset.reactMounted === "1") return;
  const props = parseShellProps();
  const root = createRoot(mountNode);
  root.render(<AdminShell {...props} />);
  mountNode.dataset.reactMounted = "1";
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountReactAdminShell, { once: true });
} else {
  mountReactAdminShell();
}

window.mountReactAdminShell = mountReactAdminShell;
